var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurksAndCaicos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.875C32 25.7115 24.8365 32.875 16 32.875C7.1635 32.875 0 25.7115 0 16.875C0 16.8788 16 0.87675 16 0.875C24.8365 0.875 32 8.0385 32 16.875Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.8746H15.9996C15.9996 16.8602 15.9996 16.8462 15.9996 16.8318C15.9853 16.8461 15.9711 16.8603 15.9568 16.8746Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9.22281C16 6.4075 16 4.56281 16 0.875H15.9973C7.16194 0.8765 0 8.03931 0 16.875H8.34781V12.1743L13.0485 16.875H15.9572C15.9715 16.8607 15.9858 16.8465 16.0001 16.8322C16.0001 15.7543 16.0001 14.7924 16.0001 13.9236L11.2992 9.22281H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.96229C5.59271 4.38723 3.51228 6.4676 2.0874 8.97004V16.8754H6.26134V7.13635V7.13623H16.0005C16.0005 5.81979 16.0005 4.56566 16.0005 2.96229H8.09515Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 14.908L10.3159 9.2234H8.34839V9.22353L16.0005 16.8755H16.0006C16.0006 16.8755 16.0006 15.5188 16.0006 14.908V14.908Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0874 9.22241V16.8745C18.0874 20.602 22.957 21.7442 22.957 21.7442C22.957 21.7442 27.8265 20.602 27.8265 16.8745V9.22241H18.0874Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2607 12.0053C22.2607 12.7737 21.6378 14.7879 20.8693 14.7879C20.1009 14.7879 19.478 12.7737 19.478 12.0053C19.478 11.2368 20.8693 10.614 20.8693 10.614C20.8693 10.614 22.2607 11.2368 22.2607 12.0053Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9529 13.5206C26.1774 12.9728 26.352 12.172 26.352 11.7734C26.352 11.133 25.5172 10.614 25.5172 10.614C25.5172 10.614 24.6824 11.1331 24.6824 11.7734C24.6824 12.172 24.857 12.9728 25.0815 13.5206L24.5996 14.6087C24.8829 14.7238 25.1925 14.7878 25.5172 14.7878C25.8419 14.7878 26.1515 14.7238 26.4347 14.6087L25.9529 13.5206Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9134 16.8749C21.9134 16.8749 21.2178 18.2662 21.2178 19.6575H24.696C24.696 18.2662 24.0003 16.8749 24.0003 16.8749L22.9568 16.1793L21.9134 16.8749Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 16.8748V16.527C23.9996 15.9507 23.5324 15.4834 22.9561 15.4834C22.3798 15.4834 21.9126 15.9506 21.9126 16.527V16.8748H23.9996Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurksAndCaicos);
export default __webpack_public_path__ + "static/media/turks-and-caicos.ec4b0050.svg";
export { ForwardRef as ReactComponent };